import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckNodeTypes } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithAvailability } from '@utils/formatter';

import { ICMMavenirVendor, TCMNodeTypesOptions } from '@interfaces/cmModule/cmModule';
import { TCMNodeVendorTechnology } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_NODE } from '@constants/queryKeys';

type TUseQueryHistoryCheckNodeTypes = ICMMavenirVendor & TCMNodeVendorTechnology

interface IUseQueryHistoryCheckNodeTypesReturnValue {
	nodesTypesOptions: TSelectOption[];
	isFetchingNodeTypesOptions: boolean;
	isLoadingNodeTypesOptions: boolean;
}

export const useQueryHistoryCheckNodeTypes = (
	params: TUseQueryHistoryCheckNodeTypes,
): IUseQueryHistoryCheckNodeTypesReturnValue => {
	const {
		technology,
		vendor,
		isMavenirVendor,
	} = params;

	const {
		data: nodesTypesOptions,
		isFetching: isFetchingNodeTypesOptions,
		isLoading: isLoadingNodeTypesOptions,
	} = useQuery<TCMNodeTypesOptions[], TSelectOption[]>({
		queryKey: [
			HISTORY_CHECK_NODE,
			params,
		],
		queryFn: extractQueryParams(getHistoryCheckNodeTypes),
		select: (options) => optionsFormattedWithAvailability(options),
		enabled: [!!technology, !!vendor, !isMavenirVendor],
		...refetchOptions,
	});

	return {
		nodesTypesOptions: nodesTypesOptions || [],
		isFetchingNodeTypesOptions,
		isLoadingNodeTypesOptions: (isLoadingNodeTypesOptions && !!nodesTypesOptions)
			|| isFetchingNodeTypesOptions,
	};
};
